import { prop } from 'ramda';
import { connect } from 'server';
import { useEffect } from 'react';

import { useAppSelector } from 'js/store/hooks';

export const useOAPIConnect = () => {
    const openApiDomain = useAppSelector(prop('openApiDomain'));

    useEffect(() => {
        if (!openApiDomain) {
            return;
        }

        connect({ url: openApiDomain });
    }, [openApiDomain]);

    return [];
};
